import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { GetAllAgenciesResult, AgenciesService, NewAgencyModel, UpdateAgencyModel } from 'src/app/Api_Module';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'crg-create-agency-modal',
  templateUrl: './create-agency-modal.component.html'
})
export class CreateAgencyModalComponent implements OnInit {
  @Input() buttonText?: string;
  @Input() buttonClass?: string;
  @Input() buttonIcon?: string;
  @Input() agency: NewAgencyModel | UpdateAgencyModel;
  agencyId: number;
  @Output() success: EventEmitter<any> = new EventEmitter();
  titles: string[];
  loading: boolean;
  alert: any;
  updateMode: boolean;
  passwordMatch: boolean;

  constructor(private modalService: NgbModal, private agenciesService: AgenciesService, private toastr: ToastrService) { }

  ngOnInit() {

  }
  checkPasswords() {
    const _agency = this.agency as NewAgencyModel;
    this.passwordMatch = _agency.administratorPassword === _agency.administratorConfirmPassword;
    return this.passwordMatch;
  }

  openLg(content) {
    if (!!this.agency && !!this.agency['id'] && this.agency['id'] > 0) {
      this.updateMode = true;
      this.agenciesService.getAgency(this.agency['id']).subscribe((result : UpdateAgencyModel) => {
        this.agency = result;
      });
    } else {
      this.agency = {name: '', administratorName: ''};
      this.updateMode = false;
    }
    this.modalService.open(content, { size: 'lg' });
  }

  create() {
    this.agenciesService.postAgency(this.agency as NewAgencyModel).subscribe((resp) => {
      this.loading = false;
      this.agencyId = resp;
      this.success.emit({customerId: this.agencyId, owner: this.agency});
      this.toastr.success('Agency created');
      // this.alert = { type: 'success', message: 'Created! \n* customer number: ' + this.agencyId };
      this.modalService.dismissAll('success');
    },
      error => {
        this.loading = false;
        this.toastr.error('Something went wrong please try again later!');
        this.alert = { type: 'danger', message: 'Something went wrong please try again later. `-' + JSON.stringify(error.error) + '`' };
        console.log('error:' + JSON.stringify(error));
      });
  }

  update() {
    const agencyReq: UpdateAgencyModel = this.agency;
    this.agenciesService.putAgency(agencyReq.id, agencyReq).subscribe((resp) => {
      this.loading = false;
      this.agencyId = resp;
      this.toastr.success('Agency updated');
      this.success.emit({customerId: this.agencyId, owner: this.agency});
      // this.alert = { type: 'success', message: 'Created! \n* customer number: ' + this.agencyId };
      this.modalService.dismissAll('success');
    },
      error => {
        this.loading = false;
        this.toastr.error('Something went wrong please try again later!');
        this.alert = { type: 'danger', message: 'Something went wrong please try again later. `-' + JSON.stringify(error.error) + '`' };
        console.log('error:' + JSON.stringify(error));
      });
  }

  close(alert: any) {
    this.alert = null;
  }
}
